import { SIDE_NAV_OPEN } from '~/constants/localStrageKey'

export const useSideNav = () => {
  const isSideNavOpen = useLocalStorage(SIDE_NAV_OPEN, true, {
    listenToStorageChanges: true,
  })

  const openSideNav = () => {
    isSideNavOpen.value = true
  }

  const closeSideNav = () => {
    isSideNavOpen.value = false
  }

  return {
    isSideNavOpen: computed(() => isSideNavOpen.value),
    openSideNav,
    closeSideNav,
  }
}
